import { initTabBeacon } from 'shared/sophia_tab_beacon'

initTabBeacon()
